import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { LiteratureDocument } from '@types';
import { Logger } from '@utils/logger';
import { Observable, of } from 'rxjs';
import { TopFormService } from './service/top-form.service';
import { LiteratureContentDocument } from '@types';
import { catchError } from 'rxjs/operators';

const logger = Logger.getLogger('TopFormsComponent');
/**
 * top-form page is configured at Bloomreach
 * will show all documents that are configured at part of Top-form
 */
@Component({
  selector: 'ft-top-forms',
  templateUrl: './top-forms.component.html',
  styleUrls: ['./top-forms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopFormsComponent extends AbstractBaseComponent implements OnInit {
  contentLiteratureList = [];
  LiteratureContentDocument: LiteratureContentDocument[];
  constructor(private topFormService: TopFormService) {
    super();
  }
  data$: Observable<LiteratureDocument[]>;
  paramMap: Map<string, string>;

  ngOnInit(): void {
    this.paramMap = new Map();
    const content = this.document.getData();
    if (content) {
      this.LiteratureContentDocument = content.literatureListContent?.map(
        (item) => {
          return {
            url: item.linkURL?.url,
            literatureCode: item.literatureCode,
            title: item.title,
            description: item.description?.value,
          };
        }
      );
      // filters all litCodes from the top-form object
      const litCode = content.literatureListContent?.map(
        (item) => item.literatureCode
      );
      this.paramMap.set('literatureCode', litCode.toString());
      this.paramMap.set('cache', 'true');
      // populates documents based on litCodes filters
      this.data$ = this.topFormService
        .populate(this.paramMap, this.LiteratureContentDocument)
        .pipe(
          catchError((errorResponse) => {
            if (errorResponse?.status === 404) {
              logger.warn(
                '[populate]' +
                  errorResponse?.message +
                  ' code: ' +
                  errorResponse?.error?.message
              );
              return of({} as LiteratureDocument[]);
            }
          })
        );
    }
  }

  linkToNavigateDetailPage(literatureCode: string): string {
    return this.topFormService.linkToNavigateDetailPage(literatureCode);
  }
}
